import styled from '@emotion/styled';
import { Flex } from '$layouts/flex';
import { mq } from '$lib/helpers';
import { flexCenter } from '$lib/style-helpers';
import { InputField } from '$components/elements/input-field';

export const CloseButton = styled.button(({ theme }) => ({
    background: 'none',
    marginBottom: theme.space[5],
    border: 'none',
    fontSize: '30px',
    lineHeight: '30px',
    ...flexCenter,
    padding: 0,
}));

export const StyledInputField = styled(InputField)({
    width: '100%',
});

export const ChildSignupContainer = styled(Flex)(({ theme }) => ({
    position: 'relative',
    minHeight: '6.125rem',
    marginBottom: theme.space[4],
    border: `1px solid ${theme.colors.grey}`,
    borderLeft: `30px solid ${theme.colors.red}`,
    borderRadius: theme.general.borderRadius,
    padding: `${theme.space[3]} ${theme.space[4]} ${theme.space[5]}`,
}));

export const ChildSignupLegend = styled.span(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'rotate(90deg)',
    transformOrigin: '0 0',
    color: theme.colors.white,
    lineHeight: '1.875rem',
    padding: '0 5px',
}));

export const FormFooter = styled(Flex)(({ theme }) => ({
    marginBottom: theme.space[4],

    [mq('xs', 'md')]: {
        '> *': {
            flex: '1',
        },
    },

    [mq('md')]: {
        justifyContent: 'flex-end',
    },
}));
